import React, { useMemo } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../../contexts/LanguageContext';
import NewButton from '../../../../components/NewButton/NewButton';
import GenericTableFilter from '../../../../components/common/GenericTableFilter';
import useDealerRegistrationData from './hooks/useDealerRegistrationData';
import DealerRegistrationTable from './components/DealerRegistrationTable';

const DealerRegistrationPage = () => {
    const { th } = useLanguage();
    const navigate = useNavigate();

    const { items, totalCount, loading, pagination, onPageChange, includeRejected, setIncludeRejected, filterFields, handleApplyFilters, handleResetFilters } = useDealerRegistrationData();

    const initialFilters = useMemo(() => ({ sapDealerId: null, overallStatuses: [], country: null }), []);

    const handleOpen = (row) => {
        // Pending iken de detay/kilit görünümü için edit sayfasına gidilir.
        if (row.sapDealerId) {
            navigate(`/management/dealer-registration/dealer/${row.sapDealerId}`);
            return;
        }
        if (row.dealerAddressBrandId) {
            navigate(`/management/dealer-registration/edit/${row.dealerAddressBrandId}`);
        }
    };

    const handleNew = () => {
        navigate('/management/dealer-registration/new');
    };

    return (
        <div className="card">
            <div className="flex flex-row align-items-center justify-content-between mb-3">
                <h4 className="m-0">{th('dealerRegistration.listTitle')}</h4>
                <div className="flex align-items-center gap-3">
                    <div className="field-checkbox m-0">
                        <Checkbox inputId="includeRejected" checked={includeRejected} onChange={(e) => setIncludeRejected(e.checked)} />
                        <label htmlFor="includeRejected" className="ml-2">
                            {th('dealerRegistration.filter.includeRejected')}
                        </label>
                    </div>
                    <NewButton label={th('dealerRegistration.newRecord')} onClick={handleNew} />
                </div>
            </div>

            <div className="mb-2">
                <GenericTableFilter filterFields={filterFields} initialFilters={initialFilters} onApplyFilters={handleApplyFilters} onResetFilters={handleResetFilters} />
            </div>

            <DealerRegistrationTable items={items} loading={loading} totalCount={totalCount} pagination={pagination} onPageChange={onPageChange} onOpen={handleOpen} />
        </div>
    );
};

export default DealerRegistrationPage;
